import { importLibrary, setOptions } from '@googlemaps/js-api-loader'
import { GOOGLE_API_KEY } from '../env'

let mapsLoaderInitialized = false

export const ensureMapsLoader = (): void => {
  if (mapsLoaderInitialized) return

  setOptions({
    key: GOOGLE_API_KEY,
    libraries: ['places'],
  })
  mapsLoaderInitialized = true
}

export const loadPlacesLibrary = (): Promise<unknown> => {
  const existingPlaces = (window as Window & { google?: { maps?: { places?: unknown } } }).google?.maps?.places
  if (existingPlaces) return Promise.resolve(existingPlaces)

  ensureMapsLoader()
  return importLibrary('places')
}
